import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.iconName = "next-arrow";
config.shape = `<polyline fill="var(--fill)" stroke="var(--stroke)" stroke-width="var(--stroke-width)" points="7 2 17 12 7 22"></polyline>`;
let NextArrowSVG = new SvgFactory(config);

export default NextArrowSVG;



 